module.exports = __webpack_public_path__ + "img/BO.e521d084.svg";